<template>
  <div class="consulting">
    <div
      class="consulting__hero"
      style="background-image: url('/images/consulting/bg-hero-fastfive.jpg');"
    >
      <div class="consulting__hero-container">
        <div class="consulting__hero-contents">
          <div class="consulting__hero-title">
            멤버 전용 혜택받고 60일 무료로 시작하기
          </div>
          <p class="consulting__hero-description">
            FASTFIVE 멤버만을 위한 무료 서비스를 제공합니다.<br />
            60일 무료로 사용해보시고, 계약은 나중에 하세요.
          </p>
        </div>
      </div>
    </div>

    <ValidationObserver ref="form">
      <form @submit.prevent="onSubmit" class="form">
        <input id="uuid" v-model="uuid" hidden />

        <ValidationProvider
          v-slot="{ errors }"
          name="회사명 "
          mode="lazy"
          rules="required"
          slim
        >
          <div class="form__field">
            <label for="company-name" class="label label--required"
              >회사명</label
            >
            <input
              id="company-name"
              v-model="companyName"
              name="company-name"
              class="input"
              type="text"
              placeholder=""
            />
            <p class="validation-msg">
              {{ errors[0] }}
            </p>
          </div>
        </ValidationProvider>

        <div class="grid">
          <div class="grid__cell col-1/2">
            <ValidationProvider
              v-slot="{ errors }"
              name="입주지점 "
              mode="lazy"
              rules="required"
              slim
            >
              <div class="form__field">
                <label for="branch_office" class="label label--required"
                  >입주지점</label
                >
                <input
                  id="branch_office"
                  v-model="branch_office"
                  name="branch_office"
                  class="input"
                  type="text"
                  placeholder=""
                />
                <p class="validation-msg">
                  {{ errors[0] }}
                </p>
              </div>
            </ValidationProvider>
          </div>
          <div class="grid__cell col-1/2">
            <ValidationProvider
              v-slot="{ errors }"
              name="호실 "
              mode="lazy"
              rules="required"
              slim
            >
              <div class="form__field">
                <label class="label label--required" for="room_number"
                  >호실</label
                >
                <input
                  id="room_number"
                  v-model="room_number"
                  class="input"
                  name="room_number"
                  type="tel"
                  placeholder=""
                />
                <p class="validation-msg">
                  {{ errors[0] }}
                </p>
              </div>
            </ValidationProvider>
          </div>
        </div>

        <ValidationProvider
          v-slot="{ errors }"
          name="전화번호 "
          mode="lazy"
          rules="required|numeric|min:7"
          slim
        >
          <div class="form__field">
            <label class="label label--required" for="phone_number"
              >전화번호</label
            >
            <input
              id="phone_number"
              v-model="phone"
              class="input"
              name="phone_number"
              type="tel"
              placeholder="전화번호를 입력해주세요."
            />
            <p class="validation-msg">
              {{ errors[0] }}
            </p>
          </div>
        </ValidationProvider>

        <ValidationProvider
          v-slot="{ errors }"
          name="이메일 "
          mode="lazy"
          rules="required|email"
          slim
        >
          <div class="form__field">
            <label for="email" class="label label--required">이메일</label>
            <input
              id="email"
              v-model="email"
              class="input"
              name="email"
              type="email"
            />
            <p class="validation-msg">
              {{ errors[0] }}
            </p>
            <p class="form__description">
              이메일 주소를 입력하시면 상세한 혜움 서비스 소개서를 보내드립니다.
            </p>
          </div>
        </ValidationProvider>

        <div class="form__field">
          <label for="consult-content" class="label">상담내용</label>
          <textarea
            id="consult-content"
            v-model="content"
            class="textarea"
            name="consult-content"
            cols="30"
            rows="5"
            placeholder="현재 겪고 계신 어려움 또는 기타 궁금한 사항을 적어주세요."
          ></textarea>
        </div>

        <div class="form__field">
          <button type="submit" class="btn btn--primary form__submit">
            서비스 신청하기
          </button>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>
<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import consulting from '~/components/mixins/consulting.js'

export default {
  layout: 'invert-font-header',
  components: {
    ValidationObserver,
    ValidationProvider
  },
  mixins: [consulting],
  data() {
    return {
      phone: '',
      email: '',
      companyName: '',
      content: '',
      branch_office: '',
      room_number: ''
    }
  },
  methods: {
    async consultationRequest() {
      this.$nuxt.$loading.start()

      await this.requestLeadApi('post', 'fastfive', {
        company_name: this.companyName,
        phone: this.phone,
        email: this.email,
        content: this.content,
        ga_code: this.uuid,
        fastfive_branch: this.branch_office,
        fastfive_room_number: this.room_number,
        ...this.utmParams
      })

      this.$nuxt.$loading.finish()
      this.$router.push('/consulting-complete')
      return Promise.resolve()
    }
  }
}
</script>
